import { useSegments } from "expo-router";
import { useEffect } from "react";

import { useAuthState } from "@/auth/AuthProvider";
import { rememberPostLoginReturn } from "@/auth/postLoginReturn";
import { hasFirebaseClientConfig } from "@/firebase/client";
import { useAppRouter } from "@/lib/appRouter";

const PUBLIC_ROUTES = new Set([
  "login",
  "auth",
  "privacy",
  "support",
  "delete-account",
  // Android families reach this from the launch email before they can install
  // the app at all — it must never bounce them to a sign-in screen.
  "android",
  "gift"
]);

export function useRequireAuth() {
  const router = useAppRouter();
  const segments = useSegments();
  const { loading, signedIn } = useAuthState();

  useEffect(() => {
    if (!hasFirebaseClientConfig || loading || signedIn) return;
    const first = segments[0];
    if (first && PUBLIC_ROUTES.has(String(first))) return;
    rememberPostLoginReturn();
    router.replace("/login");
  }, [loading, router, segments, signedIn]);
}
